import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "phone", "code", "country", "countryCode"]
  static values = {
    defaultCountry: { type: String, default: "BR" },
    defaultCountryCode: { type: String, default: "55" }
  }

  connect() {
    this.loadDependencies()
  }

  async loadDependencies() {
    try {
      // Carrega os dados dos países e o IMask em paralelo
      const [countriesModule, IMaskModule] = await Promise.all([
        import('countries-phone-masks/src/countries.json'),
        import('imask')
      ])

      this.countries = countriesModule.default
      this.IMask = IMaskModule.default

      this.populateCountries()
      this.initializePhoneMask(this.defaultCountryValue)
    } catch (error) {
      console.error("Erro ao carregar dependências:", error)
    }
  }

  populateCountries() {
    if (!this.hasSelectTarget) return

    // Limpa o select
    this.selectTarget.innerHTML = ''

    this.countries.forEach(country => {
      const option = document.createElement('option')
      option.value = country.code

      // Cria o conteúdo da opção com bandeira e nome
      const flagUrl = `https://flagcdn.com/${country.iso.toLowerCase()}.svg`
      let countryName = `${country.name} (${country.code})`
      if (country.iso === 'BR') {
        countryName = 'Brasil (+55)'
      }

      // Usa emoji como fallback caso a bandeira não carregue
      option.innerHTML = `
        <div class="country-option">
          <img src="${flagUrl}" alt="${countryName} flag" class="country-flag">
          ${countryName}
        </div>
      `
      option.setAttribute('data-flag', flagUrl)
      option.setAttribute('data-name', countryName)

      if (country.iso === this.defaultCountryValue) {
        option.selected = true
      }

      this.selectTarget.appendChild(option)
    })

    // Adiciona o evento para estilizar o select
    this.styleSelect()
  }

  styleSelect() {
    const select = this.selectTarget
    const selectedOption = select.options[select.selectedIndex]
    const flagUrl = selectedOption.getAttribute('data-flag')

    // Adiciona a bandeira ao select
    select.style.backgroundImage = `url(${flagUrl})`
    select.style.backgroundRepeat = 'no-repeat'
    select.style.backgroundPosition = '8px center'
    select.style.backgroundSize = '20px'
    select.style.paddingLeft = '36px'
  }

  selectCountry(event) {
    const code = event.target.value
    const country = this.countries.find(c => c.code === code)

    if (country) {
      this.styleSelect()

      if (this.hasPhoneTarget) {
        this.phoneTarget.value = ''
        this.countryTarget.value = country.iso
        this.countryCodeTarget.value = country.code
      }

      this.updatePhoneMask(country)
    }
  }

  initializePhoneMask(countryIso) {
    const country = this.countries.find(c => c.iso === countryIso)
    if (country) {
      this.updatePhoneMask(country)
    }
  }

  updatePhoneMask(country) {
    if (this.hasPhoneTarget) {
      if (this.maskInstance) {
        this.maskInstance.destroy()
        this.maskInstance = null
      }

      if (country.iso === 'BR') {
        this.maskInstance = this.IMask(this.phoneTarget, {
          mask: [
            {
              mask: '(00) 0000-0000'
            },
            {
              mask: '(00) 00000-0000'
            }
          ],
          dispatch: (appended, dynamicMasked) => {
            const number = (dynamicMasked.value + appended).replace(/\D/g, '')
            return number.length <= 10
              ? dynamicMasked.compiledMasks[0]
              : dynamicMasked.compiledMasks[1]
          }
        })
      } else {
        this.phoneTarget.placeholder = 'Digite o número'
      }
    }
  }

  disconnect() {
    if (this.maskInstance) {
      this.maskInstance.destroy()
    }
  }
}